const roleAccessMap = {
    "company-admin": [
      "/dashboard",
      "/company_employees",
      "/add_employee",
      "/company_locations",
      "/add_location",
      "/company_courses",
      "/courses",
      "/employee_courses",
      "/course_instructions",
      "/company_coursefolders",
      "/company_certificates",
      "/certificate_details",
      "/employee_certificates",
      "/employee_resources",
      "/employee_documents",
      "/login_report",
      "/activity_report",
      "/course_fail_pass_report",
      "/documents-report",
      "/scorm-report",
      "/scorm-report/details/employee/:employee_id/course/:course_id",
      "/tutorial_video",
      "/account",
      "/create_course",
      "/edit_course",
      "/lesson_form",
      "/notification",
    ],
    manager: [
      "/dashboard",
      "/company_employees",
      "/add_employee",
      "/company_locations",
      "/company_coursefolders",
      "/course_instructions",
      "/employee_courses",
      "/company_certificates",
      "/certificate_details",
      "/employee_certificates",
      "/employee_resources",
      "/employee_documents",
      "/login_report",
      "/activity_report",
      "/course_fail_pass_report",
      "/documents-report",
      "/scorm-report",
      "/scorm-report/details/employee/:employee_id/course/:course_id",
      "/tutorial_video",
      "/account",
      "/lesson_form",
      "/notification",
    ],
    employee: [
      "/dashboard",
      "/employee_courses",
      "/employee_certificates",
      "/employee_resources",
      "/employee_documents",
      "/tutorial_video",
      "/add_employee",
      "/course_instructions",
      "/lesson_form",
      "/notification",
    ],
  };

  // src/router/routeAccess.js

  export const publicRoutes = [
    '/certificate-access',
    '/rhode_island',
    '/login',
    '/register',
    '/register_1-3_locations',
    '/user_register',
    '/signup',
    '/new_registration',
    '/new_sign_up',
    '/new-user_register',
    '/company_register',
    '/user_register2',
    '/new_user_register_nd',
    '/company_register_nd',
    '/boston_user_register',
    '/home',
    '/forget_password',
    '/reset_password',
    '/tour',
    '/price',
    '/account_type',
    '/boston-college',
    '/boston_login',
    '/boston_forget_password',
    '/church_login',
    '/church_forget_password',
    '/concord-hospitality',
    '/mra-login',
    '/mra-signup',
    '/mra-register',
    '/mra-corporate-register',
    '/nvra-login',
    '/nvra-signup',
    '/nvra-register',
    '/nvra-corporate-register',
    '/orla-login',
    '/orla-signup',
    '/orla-register',
    '/orla-corporate-register',
    '/not_authorized',
    '/NotFound',
    '/payment-information',
    '/shift4/link/install',
    '/home',
    '/professionals',
    '/homeowners',
    '/forgot_password'
  ];

  export const protectedRoutes = [
    '/dashboard',
    '/all_companies',
    '/edit_company',
    '/certificates',
    '/courses',
    '/create_course',
    '/course_folder',
    '/course_folder_details',
    '/create_course_folder',
    '/certificate_details',
    '/create_company',
    '/test_question_report',
    '/survey_report',
    '/survey_submissions',
    '/survey_submissions_detail',
    '/account',
    '/tutorial_video',
    '/add_tutorial_video',
    '/tour_page',
    '/add_tour_video',
    '/create_certificate',
    '/all_users',
    '/create_user',
    '/company_locations',
    '/add_location',
    '/company_certificates',
    '/company_courses',
    '/location_details',
    '/company_coursefolders',
    '/course_catalog',
    '/company_course_details',
    '/course_instructions',
    '/lesson_form',
    '/edit_course',
    '/employee_certificates',
    '/employee_resources',
    '/employee_documents',
    '/employee_courses',
    '/employee_course_purchase',
    '/add_employee',
    '/company_employees',
    '/resources',
    '/login_report',
    '/activity_report',
    '/documents-report',
    '/course_fail_pass_report',
    '/onboarding_report',
    '/all_onboarding_report',
    '/hrform_report',
    '/create_subadmin',
    '/promo_codes',
    '/create_promo_code',
    '/promo_code_report',
  ];


  export default roleAccessMap;

